// Events
import { SEARCH_QUERY, SEARCH_RESET, SEARCH_RESULT, SEARCH_SUGGESTIONS } from 'events';

export const createCustomSearchBox = (ctx) => {
  const { connectSearchBox } = window.instantsearch.connectors;

  const renderSearchBox = (renderOptions, isFirstRender) => {
    const { refine } = renderOptions;

    if (isFirstRender) {
      ctx.on(SEARCH_QUERY, (state) => {
        refine(state.search.query);
      });

      ctx.on(SEARCH_RESET, ({ search }) => {
        ctx.emit(SEARCH_QUERY, { search: { ...search, query: '' } });
      });
    }
  };

  return connectSearchBox(renderSearchBox);
};

export const createCustomHits = (ctx, type) => {
  const { connectHits } = window.instantsearch.connectors;

  let searchBoxQuery;

  ctx.on(SEARCH_QUERY, ({ search }) => {
    searchBoxQuery = search.query;
  });

  const renderHits = (renderOptions, isFirstRender) => {
    if (isFirstRender) return;

    const { results } = renderOptions;
    const { query } = results;

    // Do some extra checking why renderHits is called twice on every query. Might be a bug
    if (searchBoxQuery === query) {
      ctx.emit(SEARCH_RESULT, null, [type, query !== '' ? results : {}]);
    }
  };

  return connectHits(renderHits);
};

export const createAutocomplete = (ctx) => {
  const { connectAutocomplete } = window.instantsearch.connectors;

  const renderAutocomplete = ({ indices }, isFirstRender) => {
    if (isFirstRender) return;

    ctx.emit(SEARCH_SUGGESTIONS, null, indices);
  };

  return connectAutocomplete(renderAutocomplete);
};
